<template>

	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>Artikelen</h4>

		<c-table
			ref="table"
			:columns="columns"
			:endpoint="'/api/getasnproducts/' + this.$route.params.id"
			:search="false">
		</c-table>

        <div class="c-stock__button flex flex-center margin-t-24" v-if="complete === null && this.can('Artikel aanmaken')">
			<button @click="openModalAddPrenotification" class="c-btn c-btn--hollow no-margin">
				Artikelen inklaren
			</button>
		</div>
	</div>

	<c-add-prenotification v-if="products"
		v-show="modalAddPrenotification"
		@close="modalAddPrenotification=false"
		@open-modal-scan-prenotification="openModalScanPrenotification"
		@get-data="getData"
		@added="load"
		:size="'medium'"
		:products="products"
        :orderNumber="orderNumber">
	</c-add-prenotification>

	<c-scan-prenotification v-if="product"
		v-show="modalScanPrenotification"
		@close="modalScanPrenotification=false"
		@open-modal-add-prenotification="openModalAddPrenotification"
		@open-modal-scan-bulk="openModalScanBulk"
		:size="'medium'"
		ref="scanPrenotification"
		:product="product">
	</c-scan-prenotification>

	<c-scan-bulk
		v-show="modalScanBulk"
		:size="'medium'"
		@close="modalScanBulk=false"
		@added="handleBulkScan">
	</c-scan-bulk>

</template>

<script>
import CTable from '@components/table/Table';
import CAddPrenotification from '@app/modals/AddPrenotification';
import CScanPrenotification from '@app/modals/ScanPrenotification';
import CScanBulk from '@app/modals/ScanBulk';

import { mapGetters } from 'vuex';

export default {
	components: { CTable, CAddPrenotification, CScanPrenotification, CScanBulk },
    props: {
        orderNumber: {
            required: false,
            type: String,
        }
    },
	data() {
		return {
			modalAddPrenotification: false,
			modalScanPrenotification: false,
			modalScanBulk: false,
			products: '',
			product: '',
			items: [],
			complete: '',
		}
	},
	methods: {
		openModalAddPrenotification() {
			this.modalAddPrenotification = true;
		},
		openModalScanPrenotification() {
			this.modalScanPrenotification = true;
			this.modalAddPrenotification = false;
		},
		closeModalScanPrenotification() {
			this.modalScanPrenotification = false;
			this.modalAddPrenotification = true;
		},
		openModalScanBulk(){
			this.modalScanBulk = true;
		},
		handleBulkScan(items) {
			this.$refs.scanPrenotification.addBulk(items);
		},
		getData(e){
			this.product = e;
		},
		load(reload){

			if ( reload ){
				this.$refs.table.load();
			}

			this.$xhr.get('/api/asnproducts/' + this.$route.params.id).then( ({result}) => {
				this.products = result;
				let count = 0;
				for(let i = 0; i < this.products.length; i++)
				{
					if(this.products[i].arrived >= this.products[i].expected)
					{

					}
					else{
						this.items.push(this.products[i]);
						count++;
					}
				}

				if(count === 0){
					this.complete = 1;
				}
				else{
					this.complete = null;
				}

			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Voormeldingproducten kunnen niet worden ingeladen'});
			});
		}
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'add-prenotification',
			listener: this.openModalAddPrenotification
		});
		this.$store.dispatch('listener/on', {
			event: 'scan-prenotification',
			listener: this.openModalScanPrenotification
		});
		this.$store.dispatch('listener/on', {
			event: 'scan-bulk',
			listener: this.openModalScanBulk
		});

	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'add-prenotification',
			listener: this.openModalAddPrenotification
		});
		this.$store.dispatch('listener/off', {
			event: 'scan-prenotification',
			listener: this.openModalScanPrenotification
		});
		this.$store.dispatch('listener/off', {
			event: 'scan-bulk',
			listener: this.openModalScanBulk
		});

	},
	computed: {
		columns() {
			return [
				{ name: 'product.name', label: 'Artikelomschrijving', sortable: false, sort: true },
				{ name: 'expected', label: 'Aantal', sortable: false },
				{ name: 'product.article_number', label: 'Artikelnummer', sortable: false },
                { name: 'arrived', label: 'Ingeklaard', sortable: false },
			];

		},
		...mapGetters({
			can: 'user/can',
		}),
	},
	mounted(){
		this.load(false);
	},
}
</script>
